/**
 * Утилита для приведения типа Blob к типу File
 *
 * @param {Blob} blob
 * @param {string} fileName Имя нового файла
 */
export const convertBlobToFile = (blob: Blob, fileName: string = 'file'): File => {
  return new File([blob], fileName, { type: blob.type });
};
